await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/frontend-data-set-web/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

export const ACTION_ITEM_TARGETS = {
	BLANK: 'blank',
	EVENT: 'event',
	LINK: 'link',
	MODAL: 'modal',
	MODAL_FULL_SCREEN: 'modal-full-screen',
	MODAL_LARGE: 'modal-lg',
	MODAL_PERMISSIONS: 'modal-permissions',
	MODAL_SMALL: 'modal-sm',
	SIDE_PANEL: 'sidePanel',
};
